/**
* 基础菜单 营销管理 专属商城管理 设置单位
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.standard_code" placeholder="松佰标准码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.company_name" placeholder="单位名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="adddiscount">新增</el-button>
        <el-button size="small" type="danger" @click="deldiscount">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 70%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="self_increase_code" label="自增编码" min-width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="standard_code" label="松佰单位标准码" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="company_name" label="单位名称" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_name" label="添加人" min-width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="push_ot_seller" label="是否进行推单" width="150" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div plain v-if="scope.row.push_ot_seller==true">是</div>
            <div plain v-else>否</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="新增单位"
               :visible.sync="infoDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="flashForm" :rules="attrRules" ref="flashForm" class="flashForm">
        <el-form-item label="松佰单位标准码" prop="standard_code">
          <el-input v-model="flashForm.standard_code" auto-complete="off" clearable placeholder="请输入松佰单位标准码"
                    @change="compChange(flashForm.standard_code)">
          </el-input>
        </el-form-item>
        <el-form-item label="单位名称" prop="company_name">
          <el-select v-model="flashForm.company_name" placeholder="请选择单位名称" clearable disabled>
            <el-option v-for="type in companyName" :key="type.id" :label="type.name" :value="type.company_code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否进行推单" prop="need_push">
          <el-select v-model="flashForm.need_push" placeholder="是否进行推单" clearable>
            <el-option v-for="item in needList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货人类型" prop="receiver_type">
          <el-select v-model="flashForm.receiver_type" placeholder="请选择收货人类型" clearable>
            <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSort('flashForm')">保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  activityCompanyList,
  activityCompanyAdd,
  activityCompanyDetail,
  activityCompanyDelete,
  custCompany
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入松佰单位标准码'));
        } else {
          custCompany(value)
          .then(res => {
            if (res.content) {
              callback(); // 验证成功
            } else {
              callback(new Error('未匹配到单位')); // 验证失败
            }
          })
        }
      };
      return {
        loading: false, //是显示加载
        infoDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          activity_area_id: '',
          standard_code: '',
          company_name: ''
        },
        flashForm: {
          id: "",
          activity_area_id: "",
          standard_code: "",
          company_id: "",
          company_name: "",
          need_push: "",
          receiver_type: ""
        },
        attrRules: {
          standard_code: [{required: true, validator: validateNum, trigger: 'blur'}],
          company_name: [{required: true, message: '请输入单位名称', trigger: 'blur'}],
          need_push: { required: true, message: '请选择是否进行推单', trigger: 'blur' },
          receiver_type: { required: true, message: '请选择收货人类型', trigger: 'blur' }
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        needList: [{
          name: '是',
          value: true
        }, {
          name: '否',
          value: false
        }],
        typeList: [{
          name: '客户',
          value: 2930
        }, {
          name: '子公司',
          value: 2931
        }],
        standard_code: '',
        companyName: [],
        company_id: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline);
      this.id = this.$route.query.id;
      if (this.$route.query.id) {
        localStorage.setItem('activity_area_id', this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.id = localStorage.getItem('activity_area_id')
      }
      this.formInline.activity_area_id = this.id;
    },
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        activityCompanyList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增单位
      adddiscount() {
        this.infoDialogVisible = true;
        this.dialogTitle = '新增单位';
        this.flashForm = {
          id: "",
          activity_area_id: "",
          standard_code: "",
          company_id: "",
          company_name: "",
          need_push: false,
          receiver_type: ""
        };
      },
      // 新增单位-保存
      saveSort() {
        if (!this.id) {
          this.id = localStorage.getItem('activity_area_id')
        }
        this.flashForm.activity_area_id = this.id;
        this.flashForm.company_id = this.company_id;
        this.loading = true;
        activityCompanyAdd(this.flashForm)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功单位!'
              });
              this.handleClose()
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 松佰单位标准码-单位名称
      compChange(standard_code, company_name) {
        this.$set(this.flashForm, "company_name", "");
        this.loading = true
        custCompany(standard_code)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.companyName = res.content;
                this.flashForm.company_name = res.content.company_name;
                this.company_id = res.content.id
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 删除单位
      deldiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除单位？';
        this.$confirm(title, '删除单位', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          activityCompanyDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.infoDialogVisible = false;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.standard_code == cell.innerText || row.company_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .avatar {
    width: 318px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 318px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader {
    height: 122px;
  }

  .imgtext {
    color: red;
    font-size: 12px;
    margin-left: 152px;
    width: 308px;
    margin-bottom: 20px
  }

</style>





// WEBPACK FOOTER //
// src/views/store/unitGaining.vue